import {
  ModuleId,
  configModule,
  BusinessManagerModule,
  registerModule,
  appDefIds
} from '@wix/business-manager-api'
import { ModuleRegistry, ReactLazyComponent } from 'react-module-container'
import { getTriggersConfig } from './triggersConfig'
import { getTranslations } from './getTranslations'
import { isExperimentEnabled } from './getExperiments'

import { MODULE_ID, LAZY_COMPONENT_ID, COMPONENT_ID } from './config'

const files = props => {
  const minified = debug => (debug ? '' : '.min')
  const APP_BUNDLE_FILE = 'app' // should be in sync with app's entry-point name in package.json
  return [
    `${props.config.topology.staticsUrl}${APP_BUNDLE_FILE}.bundle${minified(
      props.debug
    )}.js`,
    `${props.config.topology.staticsUrl}${APP_BUNDLE_FILE}${minified(
      props.debug
    )}.css`
  ]
};

class BMLazyComponent extends ReactLazyComponent {
  static prefetch (params) {
    return files(params)
  }

  constructor (props) {
    super(props, {
      files: files(props),
      component: COMPONENT_ID
    })
  }
}

class BMModule extends BusinessManagerModule {
  constructor (moduleId) {
    super(moduleId)
    ModuleRegistry.registerComponent(LAZY_COMPONENT_ID, () => BMLazyComponent)
  }

  async init (moduleParams) {
    // registerPageComponentMonitors(LAZY_COMPONENT_ID, {
    // sentryClient
    // });
    const translations = await getTranslations(
      moduleParams.accountLanguage,
      moduleParams.config.topology.staticsUrl
    )

    const isMobileDashboardExperimentEnabled = await isExperimentEnabled(
      'specs.wos.mobile-tab-space'
    )
   // specs.wos.mobile-tab-space
      const contact = await this.userHasApp(
        moduleParams.config.topology.staticsUrl,
        moduleParams.instance,
        moduleParams.userId,
        moduleParams.metaSiteId
      )

      const userHasApp = contact instanceof Error ? null : contact

      if (userHasApp) {
        try {
          configModule(
            MODULE_ID,
            ModuleId.Triggers,
            getTriggersConfig(appDefIds.MobileTab, translations)
          )
        } catch (e) {
          console.log('SM configure Triggers failed', e)
        }
      }
    
  }

  userHasApp (baseUrl, instance, userId, metaSiteId) {
    const fields = ['one_app', 'first_time_used_owner_app'];
    const url = window.location.origin
    return axios
      .get(`${url}/_api/wix-bi-profile-webapp/v2/user/${userId}`, {
        headers: {
          Authorization: instance,
          'Content-Type': 'application/json'
        },
        params: {
          metasiteGuid: metaSiteId,
          fields: fields
        }
      })
      .then(respone => {
        const res = _.get(respone.data.fields, 'one_app', false)
        return res
      })
      .catch(error => error)
  }
}

registerModule(MODULE_ID, BMModule)
